import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/train"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7923 1H12.2077C13.1935 1 14 1.79213 14 2.7603L14.0001 11.1199C14.0001 11.6479 13.6416 12 13.1039 12H11.3566L12.6566 15H10.4769L9.17688 12H6.78663L5.51164 15H3.33851L4.6135 12H2.89621C2.35852 12 2.00006 11.6479 2.00006 11.1199L2 2.7603C2 1.79213 2.80653 1 3.7923 1ZM3.99988 6H11.9999V3H3.99994L3.99988 6ZM5.00006 10.5C5.55235 10.5 6.00006 10.0523 6.00006 9.5C6.00006 8.94772 5.55235 8.5 5.00006 8.5C4.44778 8.5 4.00006 8.94772 4.00006 9.5C4.00006 10.0523 4.44778 10.5 5.00006 10.5ZM12.0001 9.5C12.0001 10.0523 11.5523 10.5 11.0001 10.5C10.4478 10.5 10.0001 10.0523 10.0001 9.5C10.0001 8.94772 10.4478 8.5 11.0001 8.5C11.5523 8.5 12.0001 8.94772 12.0001 9.5Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Train16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Train16 = createIcon(IconComponent);